"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthConnector = void 0;
const auth_1 = require("@aws-amplify/auth");
class AuthConnector {
    static configureAuth(config) {
        auth_1.Auth.configure(config);
    }
    static async getToken() {
        try {
            const response = await auth_1.Auth.currentSession();
            return response.getAccessToken().getJwtToken();
        }
        catch (_a) {
            return '';
        }
    }
    static async getTrustedApiHeaders() {
        const bearerToken = await AuthConnector.getToken();
        const headers = new Headers();
        headers.set('Authorization', `Bearer ${bearerToken}`);
        headers.set('Content-Type', `application/json`);
        return headers;
    }
    static async getSessionIdPayload() {
        const response = await auth_1.Auth.currentSession();
        return response.getIdToken().decodePayload();
    }
    static async getTokenServerList() {
        const payload = await AuthConnector.getSessionIdPayload();
        return payload['cognito:groups'] || [];
    }
    static async isDomainAllowed(currentLocation) {
        const servers = await AuthConnector.getTokenServerList();
        return process.env.NODE_ENV === 'production' ? !!servers.find(server => server === currentLocation.origin) : true;
    }
    static async isUserLoggedIn() {
        try {
            // will throw an exception if no session
            await auth_1.Auth.currentSession();
            return true;
        }
        catch (err) {
            return false;
        }
    }
    static async completeNewPassword(user, password) {
        return auth_1.Auth.completeNewPassword(user, password);
    }
    static login(username, password) {
        return auth_1.Auth.signIn(username, password);
    }
    static sendAuthCode(user, authCode) {
        return auth_1.Auth.confirmSignIn(user, authCode);
    }
    static async logout() {
        await auth_1.Auth.signOut();
    }
    static async forgotPassword(username) {
        return auth_1.Auth.forgotPassword(username);
    }
    static async forgotPasswordSubmit(user, code, password) {
        return auth_1.Auth.forgotPasswordSubmit(user, code, password);
    }
}
exports.AuthConnector = AuthConnector;
//# sourceMappingURL=AuthConnector.js.map